import { render } from "./AvDosya_GelenGiden_Edit.vue?vue&type=template&id=456334c2"
import script from "./AvDosya_GelenGiden_Edit.vue?vue&type=script&lang=js"
export * from "./AvDosya_GelenGiden_Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__